// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/packages/scss/base.scss
// module id = 115
// module chunks = 0